import React, { Component } from 'react';
import Chart from 'chart.js';
import Skeleton from 'react-loading-skeleton';
import { commaingNumber } from '../../../utils';
import { DS_CHART_TOKENS, getCanvasChartColor } from '../../../utils/chartTheme';

const mapGraphColor = (color) => (
  Array.isArray(color) ? color.map(getCanvasChartColor) : getCanvasChartColor(color)
);

class GroupedBarGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myChart: null,
    };
  }
  drawGraph = () => {
    var ctx = document.getElementById(this.props.id).getContext('2d');
    /**setting width of bar graph*/
    ctx.canvas.parentNode.style.width = this.props.width;

    const getBarTag = (type, value) => {
      if (!type) return '';
      else if (type === 'value') return value;
      else if (type === 'percentage') return value + '%';
    };


    if (this.state.myChart) {
      this.state.myChart.destroy();
    }

    this.state.myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.props.label,
        datasets: this.props.graphData.map((dataset) => ({
          ...dataset,
          backgroundColor: mapGraphColor(dataset.backgroundColor),
          borderColor: mapGraphColor(dataset.borderColor),
        }))
    },

      options: {
        maintainAspectRatio: false /**to set custom height and width of bar graph set maintainAspectRatio to false*/,
        barTag: 'percentage',
        legend: {
          display: true,
          position: 'bottom',
          align: 'center',
          labels: {
            boxWidth: 10,
            padding: 16,
            usePointStyle: true,
            fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray700),
            fontFamily: 'Inter',
            fontSize: 12,
            fontStyle: '500',
          },
        },
        tooltips: {
          enabled: false,
        },
        scales: {
          xAxes: [
            {
              maxBarThickness: 16,
              barThickness: 12,
              scaleLabel: {
                display: true,
                labelString: this.props.xAxesLabel,
                fontStyle: 'bold',
                fontSize: 11,
                fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray700),
                fontFamily: 'Inter',
              },
              gridLines: {
                display: false,
                color: getCanvasChartColor(DS_CHART_TOKENS.gray200),
                zeroLineColor: getCanvasChartColor(DS_CHART_TOKENS.gray300),
              },
              ticks:
                {min: 0, max: 120, fontFamily: '"JetBrains Mono"', fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray600), fontSize: 11 },
            },
          ],
          yAxes: [
            {
              maxBarThickness: 16,
              barThickness: 12,
              scaleLabel: {
                display: true,
                labelString: this.props.yAxesLabel,
                fontStyle: 'bold',
                fontSize: 11,
                fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray700),
                fontFamily: 'Inter',
              },
              gridLines: {
                drawBorder: false,
                display: true,
                color: getCanvasChartColor(DS_CHART_TOKENS.gray200),
                zeroLineColor: getCanvasChartColor(DS_CHART_TOKENS.gray300),
              },
              ticks:
              {min: 0, max: 100, stepSize: 20, fontFamily: '"JetBrains Mono"', fontColor: getCanvasChartColor(DS_CHART_TOKENS.gray600), fontSize: 11, padding: 8},
              stacked: false,
            },
          ],
        },
        animation: {
            duration: 1,
            onComplete: function () {
              var chartInstance = this.chart;
              ctx = chartInstance.ctx;
              ctx.textAlign = 'center';
              ctx.font = Chart.helpers.fontString(11, '500', '"JetBrains Mono"');
              ctx.fillStyle = getCanvasChartColor(DS_CHART_TOKENS.gray700);
              ctx.textBaseline = 'bottom';
  
              this.data.datasets.forEach((dataset, i) => {
                var meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  var data = getBarTag(this.config.options.barTag, dataset.data[index]);
                  ctx.fillText(data, bar._model.x, bar._model.y - 5);
                });
              });
            },
          },
        hover: {
          animationDuration: 0,
        },
      },
    });
  };

  componentDidMount() {
    this.drawGraph();
  }

  componentDidUpdate() {
     this.drawGraph();
  }

  render() {
    if (this.props.loading) {
      return <Skeleton width='100%' height={300} />;
    }

    return (
      /**set height of bar graph by inline styling canvas */
      <div className={`p-4 h-full ` +  'pt-6'}>
        <canvas id={this.props.id} style={{ height: 300 }}></canvas>
      </div>
    );
  }
}

export default GroupedBarGraph;
